import { ICustomExerciseType } from '#types/exerciseTypes';
import { atom, useRecoilState } from 'recoil';

/**
 * 운동 차트 작성 > 운동 선택 페이지에서 선택한 운동 리스트
 */
export const $selectedExerciseList = atom<ICustomExerciseType[]>({
  key: 'exercise',
  default: []
});

export const useSelectedExerciseListRecoil = () => {
  const [selectedExerciseList, setSelectedExerciseList] = useRecoilState(
    $selectedExerciseList
  );

  return {
    selectedExerciseList,
    setSelectedExerciseList
  };
};
